<button
  mat-button
  [type]="type ? type : null"
  [ngClass]="{
    'mat-stroked-button': stroked,
    'mat-flat-button': !stroked,
    wrap: wrapped,
    bold: bold
  }"
  [disabled]="isDisabled()"
  color="primary"
  (click)="emitClick()"
>
  <span>
    <nb-icon *ngIf="iconName" [ngClass]="'button-icon'" icon="{{ iconName }}"></nb-icon>
    <ng-content> </ng-content>
  </span>
</button>
